import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddNewQuizComponent } from './add-new-quiz/add-new-quiz.component';

const routes: Routes = [
  {
    path: 'new-quiz',
    component: AddNewQuizComponent,
  },

  { path: '', pathMatch: 'full', redirectTo: 'catalog/quizzes/new-quiz' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class QuizzesRoutingModule {}
